'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var HTTP = require('ipfs-utils/src/http.js');

var debug = require('debug');

var PQueue = require('p-queue');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var HTTP__default = /*#__PURE__*/_interopDefaultLegacy(HTTP);

var debug__default = /*#__PURE__*/_interopDefaultLegacy(debug);

var PQueue__default = /*#__PURE__*/_interopDefaultLegacy(PQueue);

var log = Object.assign(debug__default["default"]('ipfs:preload'), {
  error: debug__default["default"]('ipfs:preload:error')
});
var Queue = PQueue__default["default"].default ? PQueue__default["default"].default : PQueue__default["default"];
var httpQueue = new Queue({
  concurrency: 4
});

function preload(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  log(url);
  return httpQueue.add( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var res, reader, _yield$reader$read, done;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return HTTP__default["default"].post(url, {
              signal: options.signal
            });

          case 2:
            res = _context.sent;
            reader = res.body.getReader();
            _context.prev = 4;

          case 5:
            if (!true) {
              _context.next = 14;
              break;
            }

            _context.next = 8;
            return reader.read();

          case 8:
            _yield$reader$read = _context.sent;
            done = _yield$reader$read.done;

            if (!done) {
              _context.next = 12;
              break;
            }

            return _context.abrupt("return");

          case 12:
            _context.next = 5;
            break;

          case 14:
            _context.prev = 14;
            reader.releaseLock();
            return _context.finish(14);

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4,, 14, 17]]);
  })));
}

exports.preload = preload;